export default {
  MASTER_TOKEN: 'IrBS0xWt5rXItycGGO9X7iYyV5sM8zKo',
  IMAGE_URL: './assets/images/',
  API_URL: process.env.REACT_APP_DOCKER
    ? `${window.location.protocol}//${window.location.hostname}/api`
    : 'http://localhost:9040/api'
}
